import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { PageHeader, MerchantBadge } from "@/components/Primitives";
import { Button } from "@/components/ui/button";

export default function Merchants() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [mcoOnly, setMcoOnly] = useState(false);
  const load = () => api.get("/merchants").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  async function add(e) {
    e.preventDefault();
    try { await api.post("/merchants", { name: name.trim(), mco_only: mcoOnly }); toast.success("Merchant added"); setName(""); setMcoOnly(false); load(); }
    catch (ex) { toast.error(apiError(ex)); }
  }
  async function patch(m, body) {
    try { await api.patch(`/merchants/${m.id}`, body); load(); } catch (ex) { toast.error(apiError(ex)); }
  }

  return (
    <div data-testid="merchants-page">
      <PageHeader eyebrow="Administration" title="Merchant Accounts" />
      <form onSubmit={add} className="panel p-4 flex flex-wrap items-center gap-3 mb-5" data-testid="merchant-form">
        <input data-testid="merchant-name-input" className="field w-64" placeholder="Merchant / gateway account name" required value={name} onChange={(e) => setName(e.target.value)} />
        <label className="text-sm flex items-center gap-2 text-slate-300"><input data-testid="merchant-mco-only" type="checkbox" checked={mcoOnly} onChange={(e) => setMcoOnly(e.target.checked)} />MCO-only account</label>
        <Button data-testid="merchant-add-btn" type="submit" className="bg-indigo-600 hover:bg-indigo-500"><Plus className="h-4 w-4 mr-1" />Add merchant</Button>
      </form>
      <div className="panel overflow-x-auto">
        <table className="w-full text-sm" data-testid="merchants-table">
          <thead className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800"><tr><th className="px-4 py-3">Merchant</th><th className="px-4 py-3">Usage</th><th className="px-4 py-3">Status</th><th className="px-4 py-3"></th></tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} className="border-b border-slate-800/70 last:border-0" data-testid={`merchant-row-${m.name}`}>
                <td className="px-4 py-3"><MerchantBadge name={m.name} /></td>
                <td className="px-4 py-3 text-slate-400">{m.mco_only ? "MCO / service fee charges only" : "Full & split charges"}</td>
                <td className="px-4 py-3"><span className={`rounded border px-2 py-0.5 text-[11px] font-semibold ${m.is_active ? "border-emerald-500/30 text-emerald-400 bg-emerald-500/10" : "border-slate-700 text-slate-500"}`}>{m.is_active ? "Active" : "Inactive"}</span></td>
                <td className="px-4 py-3 text-right whitespace-nowrap text-xs">
                  <button data-testid={`merchant-toggle-mco-${m.name}`} onClick={() => patch(m, { mco_only: !m.mco_only })} className="text-slate-400 hover:text-white mr-4">{m.mco_only ? "Allow full charges" : "Mark MCO-only"}</button>
                  <button data-testid={`merchant-toggle-active-${m.name}`} onClick={() => patch(m, { is_active: !m.is_active })} className={m.is_active ? "text-rose-300" : "text-emerald-300"}>{m.is_active ? "Deactivate" : "Activate"}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
